import { render, staticRenderFns } from "./FormDebtor.vue?vue&type=template&id=c49e5664"
import script from "./FormDebtor.vue?vue&type=script&lang=ts"
export * from "./FormDebtor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports